<template>
    <ai-form-text-box-dictionary
        ref="tbdRef"
        :callbacks="callbacks"
        :data-source="tbds"
        :display-expr="meta.extParams.displayExpr"
        :field-name-id="meta.fieldNameId"
        :field-name-text="meta.fieldNameText"
        :title="meta.title"
        :validation-rules="{ required: true }"
        :value-expr="meta.extParams.valueExpr"
        @popupShown="popupShown"
        @text-box-real-value-changed="tbExplRealValueChanged"
    >
        <div class="flex h-full w-full flex-col gap-3">
            <DxTabs :selected-index="currentTabIndex" :visible="!balIsSK" @itemClick="onTabItemClick">
                <DxItem id="0" text="РЭС" />
                <DxItem id="1" text="Организации" />
            </DxTabs>
            <ai-dictionary-grid-ro
                v-show="currentTabIndex === 0"
                ref="gridRef"
                :args="gridRoArgs"
                :meta="meta.extParams.gridRoMeta"
                @dictionary-selection-changed="selectionChanged"
            />
            <ai-dictionary-virtual-grid
                v-show="currentTabIndex === 1"
                ref="gridInstance"
                :auto-load-data="true"
                :current-value="userData[meta.fieldNameText]"
                :meta="meta.extParams.virtualGridMeta"
                @dictionarySelectionChanged="selectionChanged"
            />
        </div>
    </ai-form-text-box-dictionary>
</template>
<script setup>
import AiFormTextBoxDictionary from '@/components/card-component/ai-form-text-box-dictionary.vue';
import { DxItem, DxTabs } from 'devextreme-vue/tabs';
import AiDictionaryGridRo from '@/components/dictionary-components/ai-dictionary-grid-ro.vue';
import AiDictionaryVirtualGrid from '@/components/dictionary-components/ai-dictionary-virtual-grid.vue';
import { computed, inject, ref } from 'vue';

const props = defineProps({
    meta: {
        type: Object,
        default: () => {},
    },
    callbacks: {
        type: Object,
        default: () => ({
            userDataChanged: null,
            dotsClick: () => {},
        }),
    },
});
const userData = inject('userData');
const tbdRef = ref(null);
const currentTabIndex = ref(0);
const gridRef = ref(null);
const gridInstance = ref(null);

const gridRoArgs = computed(() => {
    if (userData.value['bal_id'] && balIsSK.value) {
        return {
            ...props.meta.extParams.gridRoArgs,
            select_args: {
                ...props.meta.extParams.gridRoArgs.select_args,
                ...{
                    filter_field: 'kod_parent',
                    filter_operator: '=',
                    filter_value: userData.value['bal_id'],
                },
            },
        };
    } else {
        return props.meta.extParams.gridRoArgs;
    }
});
const explFocusedRowKey = ref(null);
const onTabItemClick = async e => {
    if (e.itemIndex === 1) {
        if (gridInstance.value) {
            await gridInstance.value.gridInstance.loadData();
        }
    }
    currentTabIndex.value = e.itemIndex;
};
const balIsSK = computed(() => userData.value['bkod_ecls'] === 2);
const popupShown = async () => {
    if (gridRef.value) {
        await gridRef.value.gridRoRef.refreshData();
    }
    if (gridInstance.value) {
        await gridInstance.value.gridInstance.loadData();
    }
};
const userDataChange = value => {
    userData.value[props.meta.fieldNameId] = value[props.meta.extParams.valueExpr];
    userData.value[props.meta.fieldNameText] = value[props.meta.extParams.displayExpr]; // менять ключ и значение
    userData.value['ekod_parent'] = value['kod_parent'];
    userData.value['ekod_separator'] = value['kod_separator'];
    props.callbacks.userDataChanged(value);
};
const selectionChanged = async event => {
    userDataChange(event.data ? event.data : event);
    explFocusedRowKey.value = event?.key;
    tbdRef.value?.popupInstance.hide();
};
const tbExplRealValueChanged = newValue => {
    explFocusedRowKey.value = newValue;
};
const tbds = computed(() => {
    return [
        {
            [`${props.meta.extParams.valueExpr}`]: userData.value[props.meta.fieldNameId],
            [`${props.meta.extParams.displayExpr}`]: userData.value[props.meta.fieldNameText],
        },
    ];
});
</script>
